/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { NavLink } from 'react-router-dom'
import { connect } from 'react-redux'

// Store
import { actions } from 'core/store'

// Hooks
import { useLocalStorage } from 'core/hooks/storage'

// assets
import {
  OspreeLogoIcon,
  BlockchainAnalyticsIcon,
  // CaseManagementIcon,
  DirectoryIcon,
  PlusDocumentIcon,
  TravelRuleIcon,
  SettingsIcon,
  MarkerIcon,
  ZapIcon,
  ProfileIcon
} from 'assets/images/Icons'

// Styled Elements
import {
  SidebarWrapper,
  SidebarBrand,
  SidebarBrandLogo,
  SidebarMenuNav,
  SidebarMenuNavList,
  SidebarMenuNavItem,
  SidebarMenuNavLink,
  SidebarMenuNavText,

  SidebarMenuDetailed,
  // SidebarMenuNavLinkDemo,
} from './Sidebar.elements'
import ProfileSidebar from './ProfileSidebar/ProfileSidebar'
// import TravelRuleSidebar from './TravelRuleSidebar'
// import BlockchainAnalyticsSidebar from './BlockchainAnalyticsSidebar'
import DirectorySidebar from './DirectorySidebar'
import ReportsSidebar from './ReportsSidebar'
import AiCatalystSidebar from './AiCatalystSidebar'
import MoreSidebar from './MoreSidebar'

// Map Redux Props
const mapStateToProps = (state) => state
const mapDispatchToProps = actions
function Sidebar(props) {
  // Destructure
  const { children } = props

  // Local State
  const [isHovered, setIsHovered] = useState(false)
  const [hoveredTitle, setHovered] = useState('')

  // Hooks
  const [userCredentials] = useLocalStorage('userCredentials', {})

  // Refs
  const wrapperRef = useRef()
  const hoverWrapperRef = useRef()
  const hoverTimeout = useRef(null)

  // Functions
  const handleMouseEnter = (title) => {
    clearTimeout(hoverTimeout.current)
    hoverTimeout.current = setTimeout(() => {
      setHovered(title)
    }, 150) // delay in ms
  }

  const handleMouseLeave = () => {
    clearTimeout(hoverTimeout.current)
  }
  // Closing options on click away
  useOutsideHoverAlerter(hoverWrapperRef, setIsHovered)
  return (
    <SidebarWrapper
      ref={hoverWrapperRef}
      hovered={isHovered}
      display={hoveredTitle !== ''}
      onMouseLeave={() => { setHovered('') }}
    >
      <SidebarMenuNav>
        <SidebarMenuNavList>
          <SidebarBrand>
            <NavLink to="/">
              <SidebarBrandLogo>
                <OspreeLogoIcon />
              </SidebarBrandLogo>
            </NavLink>
          </SidebarBrand>

          <SidebarMenuNavItem>
            <SidebarMenuNavLink
              activeClassName="active"
              to="/travelrule"
              // className={hoveredTitle === 'travelrule' && 'activeHover'}
              // onMouseEnter={() => {
              //   if (hoveredTitle !== 'travelrule') setHovered('travelrule')
              // }}
            >
              <TravelRuleIcon />
              <SidebarMenuNavText>Travel Rule</SidebarMenuNavText>
            </SidebarMenuNavLink>
          </SidebarMenuNavItem>

          <SidebarMenuNavItem>
            <SidebarMenuNavLink
              activeClassName="active"
              to="/blockchain-analytics"
              // className={hoveredTitle === 'banalytics' && 'activeHover'}
              // onMouseEnter={() => handleMouseEnter('banalytics')}
              // onMouseLeave={handleMouseLeave}
            >
              <BlockchainAnalyticsIcon />
              <SidebarMenuNavText>Blockchain Analytics</SidebarMenuNavText>
            </SidebarMenuNavLink>
          </SidebarMenuNavItem>

          <SidebarMenuNavItem>
            <SidebarMenuNavLink
              activeClassName="active"
              to="/directory"
              className={hoveredTitle === 'directory' && 'activeHover'}
              onMouseEnter={() => handleMouseEnter('directory')}
              onMouseLeave={handleMouseLeave}
            >
              <DirectoryIcon />
              <SidebarMenuNavText>Directory</SidebarMenuNavText>
            </SidebarMenuNavLink>
          </SidebarMenuNavItem>

          <SidebarMenuNavItem>
            <SidebarMenuNavLink
              activeClassName="active"
              to="/reports"
              className={hoveredTitle === 'reports' && 'activeHover'}
              onMouseEnter={() => handleMouseEnter('reports')}
              onMouseLeave={handleMouseLeave}
            >
              <PlusDocumentIcon />
              <SidebarMenuNavText>Reports</SidebarMenuNavText>
            </SidebarMenuNavLink>
          </SidebarMenuNavItem>

          <SidebarMenuNavItem>
            <SidebarMenuNavLink
              activeClassName="active"
              to="/ai-catalyst/ospree"
              className={hoveredTitle === 'ai-catalyst' && 'activeHover'}
              onMouseEnter={() => handleMouseEnter('ai-catalyst')}
              onMouseLeave={handleMouseLeave}
            >

              <ZapIcon />
              <SidebarMenuNavText>AI Catalyst</SidebarMenuNavText>
            </SidebarMenuNavLink>
          </SidebarMenuNavItem>

          {children}
        </SidebarMenuNavList>

        <SidebarMenuNavList ref={wrapperRef}>
          <SidebarMenuNavItem>
            <SidebarMenuNavLink
              to="#"
              activeClassName="active"
              className={hoveredTitle === 'more' && 'activeHover'}
              onMouseEnter={() => handleMouseEnter('more')}
              onMouseLeave={handleMouseLeave}
            >

              <MarkerIcon />
              <SidebarMenuNavText>More</SidebarMenuNavText>
            </SidebarMenuNavLink>
          </SidebarMenuNavItem>

          <SidebarMenuNavItem>
            <SidebarMenuNavLink
              exact
              to={`/user-details/${userCredentials?.id}`}
              className={hoveredTitle === 'profile' && 'activeHover'}
              onMouseEnter={() => handleMouseEnter('profile')}
              onMouseLeave={handleMouseLeave}
            >
              <ProfileIcon />
              <SidebarMenuNavText>Profile</SidebarMenuNavText>
            </SidebarMenuNavLink>
          </SidebarMenuNavItem>
        </SidebarMenuNavList>
      </SidebarMenuNav>

      <SidebarMenuDetailed
        hovered={isHovered}
        display={hoveredTitle !== ''}
      >
        {hoveredTitle === 'more' && <MoreSidebar />}
        {hoveredTitle === 'profile' && <ProfileSidebar />}
        {/* {hoveredTitle === 'travelrule' && <TravelRuleSidebar />} */}
        {/* {hoveredTitle === 'banalytics' && <BlockchainAnalyticsSidebar />} */}
        {hoveredTitle === 'directory' && <DirectorySidebar />}
        {hoveredTitle === 'reports' && <ReportsSidebar />}
        {hoveredTitle === 'ai-catalyst' && <AiCatalystSidebar />}

      </SidebarMenuDetailed>
    </SidebarWrapper>
  )
}

// Default Props
Sidebar.defaultProps = {
  children: '',
}

// Proptypes Validation
Sidebar.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.node]),
}

export default connect(mapStateToProps, mapDispatchToProps)(Sidebar)

// Function that listens to oustide clicks of given ref
const useOutsideHoverAlerter = (ref, setShowOptions) => {
  useEffect(() => {
    function handleHoverOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        setShowOptions(false)
      } else {
        setShowOptions(true)
      }
    }
    document.addEventListener('mouseover', handleHoverOutside)
    return () => {
      document.removeEventListener('mouseover', handleHoverOutside)
    }
  }, [ref])
}
